import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ImageOverview} from '~components/images/image-overview/ImageOverview';
import {useLabelItems} from '~components/models/model.hooks';

export const Route = createFileRoute('/simsearch/')({
  component: SimsearchPage,
});

function SimsearchPage(): JSX.Element {
  const projectLabelItems = useLabelItems({from: 'project'});

  return (
    <BaseLayout>
      <ImageOverview mode='archive' currentLabels={projectLabelItems} />
    </BaseLayout>
  );
}
